/**
 * Auto generated!
 *
 * If you need to make changes edit the template in `scripts/roles/template.ts`, or else they will
 * be overwritten.
 */

export type RoleId =
  | 'none'
  | 'organization:it-manager'
  | 'organization:administrator'
  | 'organization:user'
  | 'group:manager'
  | 'group:user'
  | 'share:manager'
  | 'share:user'
  | 'share:reader'
  | 'share:videocaller'
  | 'clock:user'
  | 'clock:reader'
  | 'calendar:manager'
  | 'calendar:user'
  | 'calendar:reader'
  | 'videos:user'
  | 'contentpackages:user'
  | 'contentpackages:manager';

export type Category =
  | 'ORGANIZATION'
  | 'GROUP'
  | 'SHARE'
  | 'CLOCK'
  | 'CALENDAR'
  | 'VIDEOS'
  | 'CONTENTPACKAGES';

export interface Role {
  id: RoleId;
  category: Category;
}

export function isRole(data?: any): data is Role {
  if (!data || typeof data !== 'object') return false;
  if (typeof data.id !== 'string') return false;
  return true;
}

export const roles: Role[] = [
  {
    id: 'organization:it-manager',
    category: 'ORGANIZATION',
  },
  {
    id: 'organization:administrator',
    category: 'ORGANIZATION',
  },
  {
    id: 'organization:user',
    category: 'ORGANIZATION',
  },
  {
    id: 'group:manager',
    category: 'GROUP',
  },
  {
    id: 'group:user',
    category: 'GROUP',
  },
  {
    id: 'share:manager',
    category: 'SHARE',
  },
  {
    id: 'share:user',
    category: 'SHARE',
  },
  {
    id: 'share:reader',
    category: 'SHARE',
  },
  {
    id: 'share:videocaller',
    category: 'SHARE',
  },
  {
    id: 'none',
    category: 'SHARE',
  },
  {
    id: 'clock:user',
    category: 'CLOCK',
  },
  {
    id: 'clock:reader',
    category: 'CLOCK',
  },
  {
    id: 'none',
    category: 'CLOCK',
  },
  {
    id: 'calendar:manager',
    category: 'CALENDAR',
  },
  {
    id: 'calendar:user',
    category: 'CALENDAR',
  },
  {
    id: 'calendar:reader',
    category: 'CALENDAR',
  },
  {
    id: 'none',
    category: 'CALENDAR',
  },
  {
    id: 'videos:user',
    category: 'VIDEOS',
  },
  {
    id: 'none',
    category: 'VIDEOS',
  },
  {
    id: 'contentpackages:manager',
    category: 'CONTENTPACKAGES',
  },
  {
    id: 'contentpackages:user',
    category: 'CONTENTPACKAGES',
  },
  {
    id: 'none',
    category: 'CONTENTPACKAGES',
  },
];

export function isRoleId(data?: any): data is RoleId {
  if (!data || typeof data !== 'string') return false;
  return !!roles.find(({ id }) => id === data);
}

export function forCategory(category: Category, withoutNone?: boolean): Role[] {
  const categoryRoles = roles.filter(r => r.category === category);
  if (withoutNone) {
    return categoryRoles.filter(r => r.id !== 'none');
  }
  return categoryRoles;
}

export function groupRoles(): Role[] {
  return roles.filter(r => r.category !== 'ORGANIZATION');
}

export function role(id: RoleId): Role | undefined {
  return roles.find(r => r.id === id);
}
